<template>
  <div class="position-relative" id="examResultAll">
        <div class="row">
          <div class="col-12">
              <table class="table table-sm table-bordered">
                <tbody>
                  <tr v-if="!studentsData.length">
                    <td :colspan="examData.class_section_exam_subject.length + 1">
                      <no-data text="No Students Selected !!" />
                    </td>
                  </tr>
                  <tr v-else>
                    <td :colspan="examData.class_section_exam_subject.length + 1">
                      <no-data text="Please Select Students !!" />
                    </td>
                  </tr>
                </tbody>
              </table>

          </div>
        </div>
  </div>
</template>

<script>
import NoData from '@/components/layout/NoData/index'

export default {
  name: 'StudentMarksDisplayAll',
  components: {
    NoData,
  },
  props: ['examData', 'studentsData'],

}
</script>

<style lang="scss">
  .scroll-area {
    position: relative;
    margin: auto;
  }
</style>
